module.exports = __webpack_public_path__ + "img/rm-1.968f076e.png";